import { I18n } from '@calendly/i18n';
import { ContentArea } from '@calendly/ui/components/content-area';
import { InlineBanner } from '@calendly/ui/components/inline-banner';
import classNames from 'classnames';
import { useIsWideCenterPanelLayout, useProductRefreshAppShell } from 'features/app_shell';
import { TRACKING_EVENT_NAMES } from 'hooks/analytics_events/constants';
import { useTrack, useTrackOnce } from 'hooks/analytics_events/useTrack';
import { useAcceptTermsMutation } from './api';
const wrapperCss = "wmq2p62";
const innerIsWideCss = "i1r3shlz";
const innerCss = "i14qxjdr";
const innerAppShellCss = "iq36mmx";
const TermsOfServiceInlineBanner = ({
  handleAcceptTerms,
  handleReviewTerms,
  isAccepting
}) => <InlineBanner variant="info" hasIcon={false} isDismissible={false} title={I18n.t('publisher.terms_of_service.banner.title')} message={I18n.t('publisher.terms_of_service.banner.message')} primaryButton={{
  label: I18n.t('publisher.terms_of_service.banner.accept_terms'),
  decoration: 'primary',
  onClick: handleAcceptTerms,
  disabled: isAccepting,
  loading: isAccepting
}} secondaryButton={{
  label: I18n.t('publisher.terms_of_service.banner.review_terms'),
  decoration: 'ghost',
  onClick: handleReviewTerms
}} />;
export const TermsOfServiceBanner = ({
  orgTermsStatus
}) => {
  const isAppShell = useProductRefreshAppShell();
  const isWide = useIsWideCenterPanelLayout();
  const [acceptTerms, {
    isLoading: isAccepting
  }] = useAcceptTermsMutation();
  const track = useTrack();
  useTrackOnce(true, {
    name: TRACKING_EVENT_NAMES.CTA_SHOWN,
    properties: {
      cta_key: 'tos_update_banner',
      cta_text: 'tos_banner_2026'
    }
  });
  const newTermsUrl = orgTermsStatus?.termsLinkUrl ?? '';
  const handleReviewTerms = () => {
    track({
      name: TRACKING_EVENT_NAMES.CTA_CLICKED,
      properties: {
        action: 'interaction',
        cta_key: 'tos_update_banner',
        cta_text: 'review_terms_tos_banner'
      }
    });
    window.open(newTermsUrl, '_blank', 'noopener,noreferrer');
  };
  const handleAcceptTerms = () => {
    if (isAccepting || orgTermsStatus?.acceptedAt) return;
    track({
      name: TRACKING_EVENT_NAMES.CTA_CLICKED,
      properties: {
        action: 'interaction',
        cta_key: 'tos_update_banner',
        cta_text: 'accept_terms_tos_banner'
      }
    });
    acceptTerms().catch(() => {});
  };
  if (isAppShell) {
    return <ContentArea isWide={isWide} padding="inline" className={innerAppShellCss}>
        <TermsOfServiceInlineBanner handleAcceptTerms={handleAcceptTerms} handleReviewTerms={handleReviewTerms} isAccepting={isAccepting} />
      </ContentArea>;
  }
  return <div className={wrapperCss}>
      <div className={classNames(innerCss, {
      [innerIsWideCss]: isWide
    })}>
        <TermsOfServiceInlineBanner handleAcceptTerms={handleAcceptTerms} handleReviewTerms={handleReviewTerms} isAccepting={isAccepting} />
      </div>
    </div>;
};

require("./banner.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./banner.js");